<template>
  <!--  导航栏-->
  <div class="navBar">
    <div class="web navBarBox clearfix">
      <!-- <div class="navTitle fl" @click="goIndex">幼聘网</div> -->
      <div class="navTitle fl" @click="goIndex">
        <img :src="pclogo" alt="" />
      </div>
      <div class="changeCity fl" v-if="rou === '/'">
        <i class="el-icon-location-outline"></i>
        <span>{{ area.city_name ? area.city_name : area.provice_name }}</span>
        <el-popover placement="bottom" trigger="click">
          <el-cascader-panel
            ref="editCascader"
            :props="{ value: 'region_id', label: 'region_name' }"
            :options="cityList"
            @change="changeCity"
          ></el-cascader-panel>
          <span class="changeCityBtn" slot="reference">[切换城市]</span>
        </el-popover>
      </div>
      <div class="fl clearfix navListBox">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="navList fl"
          :class="item.active ? 'navActive' : ''"
          @click="changeNav(item, index)"
        >
          {{ item.name }}
        </div>
        <div class="navList fl" @click="goApp('https://app.ypw99.com/')">
          小程序
        </div>
        <div
          class="navList fl"
          @click="goApp('https://app.ypw99.com/h-col-105.html')"
        >
          资讯
        </div>
      </div>
      <div class="fr operation">
        <span @click="goChat" class="goChat" v-if="isLogin && is_read > 0">
          消息<el-badge
            :value="is_read"
            class="item"
            style="top: 2px"
          ></el-badge>
        </span>
        <span @click="goChat" class="goChat" v-if="isLogin && is_read === 0"
          >消息</span
        >
        <span class="resume" v-if="port === 'teacher' && isLogin">
          <span @click="goResume">简历</span>
          <span class="dian">.</span>
          <span @click="openUpload">上传</span>
        </span>
        <span v-if="!isLogin" class="goLogin" @click="goLogin"
          >注册&nbsp;/&nbsp;登录</span
        >
        <span class="user" v-if="isLogin">
          <span class="userName">{{
            port === "teacher" ? userInfo.realname : userInfo.name
          }}</span>
          <el-avatar
            size="small"
            v-if="port === 'teacher'"
            style="vertical-align: middle"
          >
            <img
              slot="default"
              :src="
                userInfo.avatar
                  ? userInfo.avatar
                  : 'http://youpinwang.oss-cn-shenzhen.aliyuncs.com/upload/20210310/e8db4be027dcd2c6cdcf972c9e775ec2.jpg?x-oss-process=image/format,jpg/resize,l_70,h_70'
              "
              alt=""
              style="width: 100%"
            />
          </el-avatar>
          <el-avatar
            size="small"
            v-if="port === 'boss'"
            style="vertical-align: middle"
          >
            <img
              slot="default"
              :src="
                userInfo.avatar
                  ? userInfo.avatar
                  : 'http://youpinwang.oss-cn-shenzhen.aliyuncs.com/upload/20210816/4baaf9f598dcc107d99d9faf9d11c315.png?x-oss-process=image/format,png/resize,l_70,h_70'
              "
              alt=""
              style="width: 100%"
            />
          </el-avatar>
          <div class="userBox">
            <div class="operationBox">
              <div v-if="port === 'boss'" @click="vipShow">升级vip</div>
              <div @click="goResume" v-if="port === 'teacher'">
                <div>个人中心</div>
                <div class="tips">推荐职位，编辑在线简历</div>
              </div>
              <div @click="goSchool" v-if="port === 'boss'">
                <div>我的园所</div>
                <div class="tips">编辑我的园所</div>
              </div>
              <div @click="goAccount()">
                <div>账号设置</div>
                <div class="tips">修改手机、修改微信</div>
              </div>
              <div @click="goAccount('3')" v-if="port === 'teacher'">
                隐私设置
              </div>
              <div style="margin-top: 5px" @click="changePort">
                切换为{{ port === "teacher" ? "招聘者" : "求职者" }}
              </div>
              <div style="margin-top: 5px" @click="signOut" v-if="isLogin">
                退出登录
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
    <upload
      :uploadDialog="uploadDialog"
      @closeUpload="closeUpload"
      @uploadSuccess="uploadSuccess"
    />

    <!-- 升级vip -->
    <el-dialog
      title="升级vip"
      :visible.sync="vipModal"
      width="30%"
      :before-close="vipShow"
    >
      <img :src="weChatCode" style="width: 100%" alt="" />
    </el-dialog>
    <div id="container" style="display: none"></div>
  </div>
</template>

<script>
import upload from "@/components/upload";
import region from "@/js/publicJson";
import pclogo from "../../assets/pclogo.png";
import { getWeChatCode } from "@/js/common.js";
import md5 from "js-md5";
import axios from "axios";

export default {
  components: {
    upload,
  },
  data() {
    return {
      pclogo: pclogo,
      port: "",
      uploadDialog: false,
      navList: [],
      userInfo: {},
      isLogin: false,
      cityList: [],
      area: {},
      rou: "/",
      is_read: "",
      vipModal: false,
      weChatCode: "",
      regionArr: [],
    };
  },
  watch: {
    $route(e) {
      this.rou = this.$route.path;
      this.navList.forEach((o) => {
        if (e.path === o.path) {
          o.active = true;
        } else {
          o.active = false;
        }
        sessionStorage.setItem("navBar", JSON.stringify(this.navList));
      });
      window.scrollTo(0, 0);
      if (this.Cookies.get("UserToken")) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      this.getRead();
      const area = sessionStorage.getItem("area");
      if (area) {
        this.area = JSON.parse(area);
      }
    },
    port() {
      if (this.port === "teacher") {
        this.navList = this.$router.options.routes.filter(
          (o) => !o.hide && o.port === "teacher"
        );
        const members = this.Cookies.get("members");
        if (members) {
          this.userInfo = JSON.parse(members);
        } else {
          this.userInfo = {};
        }
      } else {
        const schoolInfo = this.Cookies.get("schoolInfo");
        if (schoolInfo) {
          this.userInfo = JSON.parse(schoolInfo);
        } else {
          this.userInfo = {};
        }
        this.navList = this.$router.options.routes.filter(
          (o) => !o.hide && o.port === "boss"
        );
      }
      sessionStorage.setItem("navBar", JSON.stringify(this.navList));
      this.getRead();
    },
  },
  created() {
    setTimeout(() => {
      this.port = sessionStorage.getItem("port");
      if (this.Cookies.get("members")) {
        this.isLogin = true;
        if (this.port === "boss") {
          const schoolInfo = this.Cookies.get("schoolInfo");
          if (schoolInfo) {
            this.userInfo = JSON.parse(schoolInfo);
          } else {
            this.userInfo = {};
          }
        } else {
          const members = this.Cookies.get("members");
          if (members) {
            this.userInfo = JSON.parse(members);
          } else {
            this.userInfo = {};
          }
        }
        console.log(this.userInfo);
      } else {
        this.isLogin = false;
      }
    }, 1000);
  },
  mounted() {
    this.regionArr = region.region;
    this.regionArr = JSON.parse(JSON.stringify(this.regionArr));
    console.log(
      "regionArr 已初始化，数据量:",
      this.regionArr && this.regionArr.length
    );

    getWeChatCode(this, "bossjoin/pages/vipCenter/vipCenter", "1");
    let navBar = [];
    if (sessionStorage.getItem("navBar")) {
      navBar = JSON.parse(sessionStorage.getItem("navBar"));
    } else {
      navBar = this.$router.options.routes.filter(
        (o) => !o.hide && o.port === "teacher"
      );
    }
    if (this.$route.path === "/job/post") {
      navBar[0].active = false;
      navBar[1].active = true;
      sessionStorage.setItem("navBar", JSON.stringify(navBar));
    } else if (this.$route.path === "/") {
      navBar[1].active = false;
      navBar[0].active = true;
      sessionStorage.setItem("navBar", JSON.stringify(navBar));
    }

    this.rou = this.$route.path;
    if (sessionStorage.getItem("navBar")) {
      this.navList = JSON.parse(sessionStorage.getItem("navBar"));
    } else {
      if (this.port === "boss") {
        this.navList = this.$router.options.routes.filter(
          (o) => !o.hide && o.port === "boss"
        );
      } else {
        this.navList = this.$router.options.routes.filter(
          (o) => !o.hide && o.port === "teacher"
        );
      }
    }
    if (sessionStorage.getItem("area")) {
      this.area = JSON.parse(sessionStorage.getItem("area"));
      console.log("从 sessionStorage 读取城市:", this.area);
    } else {
      // 直接设置默认城市为广东省（不进行定位）
      // 用户可以通过点击"切换城市"手动选择省份和城市
      this.$nextTick(() => {
        this.setDefaultArea();
      });
    }
    this.cityList = JSON.parse(JSON.stringify(region.region));
    this.cityList.forEach((o) => {
      o.children.forEach((oa) => {
        delete oa.children;
      });
    });

    this.getRead();
  },
  methods: {
    // vip弹窗
    vipShow() {
      this.vipModal = !this.vipModal;
    },

    // 获取未读
    getRead() {
      if (this.isLogin) {
        let url = this.port === "teacher" ? "/60a87105b04fb" : "/60a8712610dd3";
        this.api.post(url, { page: 1, size: 10 }).then((r) => {
          this.is_read = r.data.list.filter((o) => o.is_read === 0).length;
        });
      }
    },

    // 去推广页面
    goApp(url) {
      window.location.href = url;
    },

    // 获取定位（使用天地图 IP 定位）
    getLocationByTianditu() {
      const tiandituKey = "81cdd6420190bffb2ff9900dab3de2b8"; // 天地图 key

      // 如果天地图 API 已加载，直接使用
      if (typeof window.T !== "undefined") {
        this.useTiandituLocation(tiandituKey);
      } else {
        // 动态加载天地图 API
        this.loadTiandituAPI(tiandituKey)
          .then(() => {
            this.useTiandituLocation(tiandituKey);
          })
          .catch(() => {
            // 如果加载失败，使用默认城市
            console.warn("天地图 API 加载失败，使用默认城市");
            this.setDefaultArea();
          });
      }
    },

    // 加载天地图 API
    loadTiandituAPI(tiandituKey) {
      return new Promise((resolve, reject) => {
        // 如果已经加载过，直接返回
        if (typeof window.T !== "undefined") {
          console.log("天地图 API 已加载");
          resolve();
          return;
        }

        // 检查是否正在加载
        if (window._tiandituLoading) {
          window._tiandituLoading.then(resolve).catch(reject);
          return;
        }

        console.log("开始加载天地图 API...");
        // 创建加载 Promise
        window._tiandituLoading = new Promise((res, rej) => {
          // 加载天地图 JavaScript API
          const script = document.createElement("script");
          script.type = "text/javascript";
          script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tiandituKey}`;
          script.async = true;

          script.onload = () => {
            console.log("天地图 API 脚本加载完成，等待 T 对象初始化...");
            // 等待 T 对象初始化
            const checkT = setInterval(() => {
              if (typeof window.T !== "undefined") {
                console.log("天地图 API 初始化成功");
                clearInterval(checkT);
                window._tiandituLoading = null;
                res();
              }
            }, 50);

            // 超时处理（10秒）
            setTimeout(() => {
              clearInterval(checkT);
              if (typeof window.T === "undefined") {
                window._tiandituLoading = null;
                console.error("天地图 API 加载超时");
                rej(new Error("天地图 API 加载超时"));
              }
            }, 10000);
          };

          script.onerror = () => {
            window._tiandituLoading = null;
            console.error("天地图 API 脚本加载失败");
            rej(new Error("天地图 API 加载失败"));
          };

          document.head.appendChild(script);
        });

        window._tiandituLoading.then(resolve).catch(reject);
      });
    },

    // 使用天地图 IP 定位
    useTiandituLocation(tiandituKey) {
      console.log("开始使用天地图 IP 定位...");

      // 方案1：使用 T.Geolocation（推荐，支持 IP 定位和 GPS 定位）
      // 方案2：如果失败，尝试使用 T.LocalCity
      // 方案3：如果都失败，使用浏览器定位 + 逆地理编码
      this.tryGeolocation(tiandituKey);
    },

    // 使用 T.Geolocation 进行定位（推荐方案）
    tryGeolocation(tiandituKey) {
      try {
        console.log("尝试使用 T.Geolocation 定位...");

        // 检查 T.Geolocation 是否可用
        if (
          typeof window.T === "undefined" ||
          typeof window.T.Geolocation === "undefined"
        ) {
          console.warn("T.Geolocation 不可用，尝试使用 LocalCity");
          this.tryLocalCity(tiandituKey);
          return;
        }

        // 创建定位对象
        const geolocation = new window.T.Geolocation();

        // 设置超时处理
        let timeoutTriggered = false;
        const timeout = setTimeout(() => {
          timeoutTriggered = true;
          console.warn("Geolocation 定位超时（8秒），尝试使用 LocalCity");
          this.tryLocalCity(tiandituKey);
        }, 8000);

        // 获取当前位置（支持 IP 定位和 GPS 定位）
        geolocation.getCurrentPosition(
          (result) => {
            if (timeoutTriggered) {
              console.log("Geolocation 回调已超时，忽略结果");
              return;
            }
            clearTimeout(timeout);
            console.log("天地图 Geolocation 定位回调触发，结果:", result);

            // 检查定位状态
            if (result.status !== 0) {
              console.warn(
                "Geolocation 定位失败，状态码:",
                result.status,
                "错误信息:",
                result.message
              );
              this.tryLocalCity(tiandituKey);
              return;
            }

            // 获取经纬度
            const lnglat = result.lnglat;
            if (!lnglat) {
              console.warn("Geolocation 未返回经纬度，尝试使用 LocalCity");
              this.tryLocalCity(tiandituKey);
              return;
            }

            console.log("Geolocation 获取到经纬度:", lnglat.lng, lnglat.lat);

            // 使用逆地理编码获取城市信息
            this.reverseGeocode(lnglat.lng, lnglat.lat, tiandituKey);
          },
          (error) => {
            clearTimeout(timeout);
            console.warn("Geolocation 定位失败，错误:", error);
            // 如果 Geolocation 失败，尝试使用 LocalCity
            this.tryLocalCity(tiandituKey);
          }
        );
      } catch (error) {
        console.error("Geolocation 定位异常:", error);
        // 如果异常，尝试使用 LocalCity
        this.tryLocalCity(tiandituKey);
      }
    },

    // 尝试使用 LocalCity 定位（备选方案）
    tryLocalCity(tiandituKey) {
      try {
        console.log("尝试使用 T.LocalCity 定位...");

        // 设置超时处理
        let timeoutTriggered = false;
        const timeout = setTimeout(() => {
          timeoutTriggered = true;
          console.warn("LocalCity 定位超时（5秒），尝试使用浏览器定位");
          this.tryBrowserGeolocation(tiandituKey);
        }, 5000);

        // 使用天地图的 LocalCity 进行 IP 定位
        if (
          typeof window.T === "undefined" ||
          typeof window.T.LocalCity === "undefined"
        ) {
          clearTimeout(timeout);
          console.warn("T.LocalCity 不可用，尝试使用浏览器定位");
          this.tryBrowserGeolocation(tiandituKey);
          return;
        }

        const lc = new window.T.LocalCity();

        // 检查 LocalCity 是否可用
        if (!lc || typeof lc.location !== "function") {
          clearTimeout(timeout);
          console.warn("LocalCity.location 方法不可用，尝试使用浏览器定位");
          this.tryBrowserGeolocation(tiandituKey);
          return;
        }

        console.log("调用 LocalCity.location...");
        lc.location((result) => {
          if (timeoutTriggered) {
            console.log("LocalCity 回调已超时，忽略结果");
            return;
          }
          clearTimeout(timeout);
          console.log("天地图 LocalCity 定位回调触发，结果:", result);

          // 检查 result 是否有效
          if (!result) {
            console.warn("LocalCity 定位返回结果为空，尝试使用浏览器定位");
            this.tryBrowserGeolocation(tiandituKey);
            return;
          }

          // result 包含：cityName（城市名称）、lnglat（经纬度）
          const cityName = result.cityName || "";

          if (!cityName) {
            console.warn(
              "LocalCity 定位返回的城市名称为空，尝试使用浏览器定位"
            );
            this.tryBrowserGeolocation(tiandituKey);
            return;
          }

          console.log("LocalCity 定位到的城市名称:", cityName);
          // 匹配城市名称到 region 数据
          this.matchCityByName(cityName);
        });
      } catch (error) {
        console.error("LocalCity 定位异常:", error);
        // 如果定位失败，尝试使用浏览器定位
        this.tryBrowserGeolocation(tiandituKey);
      }
    },

    // 使用浏览器 Geolocation API + 天地图逆地理编码
    tryBrowserGeolocation(tiandituKey) {
      if (!navigator.geolocation) {
        console.warn("浏览器不支持 Geolocation API，使用默认城市");
        this.setDefaultArea();
        return;
      }

      console.log("尝试使用浏览器 Geolocation API...");

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lng = position.coords.longitude;
          const lat = position.coords.latitude;
          console.log("获取到经纬度:", lng, lat);

          // 使用天地图逆地理编码获取城市信息
          this.reverseGeocode(lng, lat, tiandituKey);
        },
        (error) => {
          console.warn("浏览器定位失败:", error.message);
          console.log("使用默认城市");
          this.setDefaultArea();
        },
        {
          timeout: 5000,
          enableHighAccuracy: false,
        }
      );
    },

    // 天地图逆地理编码
    reverseGeocode(lng, lat, tiandituKey) {
      console.log("开始逆地理编码，经纬度:", lng, lat);

      try {
        // 使用天地图的逆地理编码服务
        const geocoder = new window.T.Geocoder();
        geocoder.getLocation(new window.T.LngLat(lng, lat), (result) => {
          console.log("逆地理编码结果:", result);

          if (!result || !result.addressComponent) {
            console.warn("逆地理编码失败，使用默认城市");
            this.setDefaultArea();
            return;
          }

          const addressComponent = result.addressComponent;
          const cityName =
            addressComponent.city || addressComponent.district || "";

          if (!cityName) {
            console.warn("逆地理编码未返回城市名称，使用默认城市");
            this.setDefaultArea();
            return;
          }

          console.log("逆地理编码获取到的城市名称:", cityName);
          this.matchCityByName(cityName);
        });
      } catch (error) {
        console.error("逆地理编码异常:", error);
        this.setDefaultArea();
      }
    },

    // 根据城市名称匹配省市区
    matchCityByName(cityName) {
      let matched = false;

      console.log("开始匹配城市名称:", cityName);
      console.log("regionArr 数据:", this.regionArr);

      // 确保 regionArr 已准备好
      if (!this.regionArr || this.regionArr.length === 0) {
        console.warn("regionArr 数据未准备好，延迟匹配");
        // 延迟重试
        setTimeout(() => {
          this.matchCityByName(cityName);
        }, 500);
        return;
      }

      // 遍历省份和城市，匹配城市名称
      this.regionArr.forEach((province) => {
        if (province.children && province.children.length > 0) {
          province.children.forEach((city) => {
            // 匹配城市名称（支持包含匹配，去除"市"后缀）
            const cityNameClean = cityName.replace(/市$/, ""); // 去除"市"后缀
            const regionCityName = city.region_name.replace(/市$/, "");

            // 更精确的匹配逻辑
            const isMatch =
              cityName === city.region_name ||
              cityName.indexOf(city.region_name) > -1 ||
              city.region_name.indexOf(cityName) > -1 ||
              cityNameClean === regionCityName ||
              regionCityName === cityNameClean ||
              regionCityName.indexOf(cityNameClean) > -1 ||
              cityNameClean.indexOf(regionCityName) > -1;

            if (isMatch) {
              console.log("匹配成功:", {
                province: province.region_name,
                city: city.region_name,
                cityName: cityName,
              });
              this.area = {
                province_id: province.region_id,
                provice_name: province.region_name,
                city_id: city.region_id,
                city_name: city.region_name,
                dist_id: "",
                dist_name: "",
              };
              sessionStorage.setItem("area", JSON.stringify(this.area));
              matched = true;
              // 匹配成功后更新显示
              this.$forceUpdate();
            }
          });
        }
      });

      // 如果匹配失败，使用默认城市
      if (!matched) {
        console.warn(`未找到匹配的城市: ${cityName}，使用默认城市`);
        console.log("尝试匹配的城市名称:", cityName);
        console.log(
          "可用的城市列表（前10个）:",
          this.regionArr
            .slice(0, 3)
            .map(
              (p) =>
                p.children && p.children.slice(0, 3).map((c) => c.region_name)
            )
        );
        this.setDefaultArea();
      }
    },

    // 设置默认城市（默认选择广东省的第一个城市）
    // 用户可以通过"切换城市"功能手动选择省份和城市
    setDefaultArea() {
      console.log("设置默认城市为广东省");

      if (!this.regionArr || this.regionArr.length === 0) {
        console.warn("regionArr 数据为空，无法设置默认城市");
        return;
      }

      // 查找广东省
      let guangdongProvince = null;
      for (let i = 0; i < this.regionArr.length; i++) {
        const province = this.regionArr[i];
        // 匹配广东省（支持"广东"、"广东省"等）
        if (
          province.region_name.indexOf("广东") > -1 ||
          province.region_name === "广东省" ||
          province.region_name === "广东"
        ) {
          guangdongProvince = province;
          break;
        }
      }

      // 如果找到广东省，使用广东省的第一个城市
      if (
        guangdongProvince &&
        guangdongProvince.children &&
        guangdongProvince.children.length > 0
      ) {
        const firstCity = guangdongProvince.children[0];
        this.area = {
          province_id: guangdongProvince.region_id,
          provice_name: guangdongProvince.region_name,
          city_id: firstCity.region_id,
          city_name: firstCity.region_name,
          dist_id: "",
          dist_name: "",
        };
        sessionStorage.setItem("area", JSON.stringify(this.area));
        console.log("默认城市已设置（广东省）:", this.area);
        // 更新显示
        this.$forceUpdate();
      } else {
        // 如果找不到广东省，使用第一个省份的第一个城市作为备选
        console.warn("未找到广东省，使用第一个省份作为默认");
        const firstProvince = this.regionArr[0];
        if (firstProvince.children && firstProvince.children.length > 0) {
          const firstCity = firstProvince.children[0];
          this.area = {
            province_id: firstProvince.region_id,
            provice_name: firstProvince.region_name,
            city_id: firstCity.region_id,
            city_name: firstCity.region_name,
            dist_id: "",
            dist_name: "",
          };
          sessionStorage.setItem("area", JSON.stringify(this.area));
          console.log("默认城市已设置（第一个省份）:", this.area);
          this.$forceUpdate();
        } else {
          console.warn("第一个省份没有城市数据");
        }
      }
    },

    // 切换城市
    changeCity(o) {
      let obj = this.$refs.editCascader.getCheckedNodes()[0];
      // this.$route.meta.title = obj.pathLabels[1] + '幼师招聘网-海量'+ obj.pathLabels[1] +'幼师招聘职位-幼聘网-中国幼师招聘网'

      this.area = {
        provice_name: obj.pathLabels[0],
        city_name: obj.pathLabels[1],
        province_id: obj.path[0],
        city_id: obj.path[1],
        dist_id: obj.path[2] ? [obj.path[2]] : [],
      };
      sessionStorage.setItem("area", JSON.stringify(this.area));
      // document.title = obj.pathLabels[1] + '幼师招聘网-海量'+ obj.pathLabels[1] +'幼师招聘职位-幼聘网-中国幼师招聘网'
      location.reload();
    },

    // 切换端
    changePort() {
      sessionStorage.setItem(
        "port",
        this.port === "teacher" ? "boss" : "teacher"
      );
      this.port = sessionStorage.getItem("port");
      if (this.port === "boss") {
        const schoolUserToken = this.Cookies.get("school_user_token");
        if (schoolUserToken && JSON.parse(schoolUserToken)) {
          this.$router.push({
            path: "/boss/resume",
          });
        } else {
          this.$router.push({
            path: "/boss/addSchool",
          });
        }
      } else {
        this.$router.push({
          // path: this.port === 'teacher'?'/':'/boss/resume'
          path: "/",
        });
      }
      this.navList[0].active = true;
      sessionStorage.setItem("navBar", JSON.stringify(this.navList));
    },

    // 关闭上传
    closeUpload(uploadDialog) {
      this.uploadDialog = uploadDialog;
    },

    // 上传成功
    uploadSuccess() {
      this.uploadDialog = false;
    },

    // 简历上传
    openUpload() {
      this.uploadDialog = true;
    },

    // 切换导航栏
    changeNav(o, i) {
      if (!o.active) {
        this.navList.forEach((o) => {
          o.active = false;
        });
        o.active = true;
        this.$router.push({ path: o.path });
        sessionStorage.setItem("navBar", JSON.stringify(this.navList));
      }
    },

    // 返回首页
    goIndex() {
      if (this.port === "teacher") {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/boss/resume" });
      }
    },

    // 去简历
    goResume() {
      this.$router.push({ path: "/job/resume" });
    },

    // 去消息
    goChat() {
      this.$router.push({ path: "/chat" });
    },

    // 编辑园所
    goSchool() {
      this.$router.push({ path: "/boss/school" });
    },

    // 去账号设置
    goAccount(type) {
      if (this.$route.path != "/job/accountNumber") {
        this.$router.push({
          path: "/job/accountNumber",
          query: {
            tabActive: type,
          },
        });
      }
    },

    // 退出登录
    signOut() {
      this.Cookies.remove("UserToken");
      this.Cookies.remove("school_user_token");
      this.Cookies.remove("schoolUser");
      this.Cookies.remove("schoolInfo");
      this.Cookies.remove("members");
      this.Cookies.remove("AccessToken");
      this.Cookies.remove("DeviceId");
      this.isLogin = false;
      this.$router.push({ path: "/" });
      this.$message({
        message: "退出成功",
        type: "success",
      });
      this.$nextTick(() => {
        this.api.get("/5cd8ef9a0b6be", {}).then((r) => {
          this.Cookies.set("DeviceId", JSON.stringify(r.data), { expires: 1 });
          this.$nextTick(() => {
            let str = `app_id=80905851&app_secret=tCVGTcYqkyhxDvjfwTXPKPiWqIPOjqjY&device_id=${
              JSON.parse(this.Cookies.get("DeviceId")).device_id
            }`;
            let md5str = md5(str);
            let obj = {
              app_id: "80905851",
              device_id: JSON.parse(this.Cookies.get("DeviceId")).device_id,
              signature: md5str,
            };
            this.api.post("/5cb6a46030b2d", obj).then((r) => {
              this.Cookies.set("AccessToken", JSON.stringify(r.data));
              this.accToken = true;
              this.AccessToken = JSON.stringify(r.data);
              if (!this.Cookies.get("DeviceId")) {
                location.reload();
              }
            });
          });
        });
      });
    },

    // 去登陆
    goLogin() {
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style scoped lang="scss">
.navBar {
  // background: #202329;
  background: #ff6637;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  padding: 5px 0;
  .navBarBox {
    // height: 49px;
    // line-height: 49px;
    height: 39px;
    line-height: 39px;
    .changeCity {
      // color: #ff5b12;
      color: white;
      font-size: 14px;
      .changeCityBtn {
        color: white;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    .navTitle {
      color: #ff5b12;
      font-weight: bold;
      font-size: 26px;
      cursor: pointer;
      margin-right: 15px;
      height: 100%;
      img {
        height: 100%;
      }
    }
    .navListBox {
      margin-left: 15px;
      .navList {
        color: white;
        cursor: pointer;
        margin: 0 10px;
        font-size: 14px;
        transition: all 0.2s;
        padding: 0 31px;
        border-radius: 5px;
      }
      .navList:hover {
        color: #ff5b12;
        background: white;
      }
      .navActive {
        color: #ff5b12;
        background: white;
      }
    }
    .goChat {
      margin-right: 20px;
      cursor: pointer;
    }
    .operation {
      color: white;
      font-size: 14px;
      position: relative;
      .resume {
        > span {
          cursor: pointer;
        }
        // > span:hover {
        //   color: #ff5b12;
        //   transition: color 0.5s;
        // }
        .dian {
          transform: translateY(-4px);
          display: inline-block;
          font-size: 18px;
        }
      }
      .user {
        margin-left: 20px;
        display: inline-block;
        .userName {
          margin-right: 10px;
        }
        .userBox {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          z-index: 99;
          padding-top: 44px;
          width: 28px;
        }
        .operationBox {
          margin-left: -322px;
          color: #333;
          width: 350px;
          box-shadow: 1px 2px 14px rgba(0, 0, 0, 0.11);
          background-color: #f2f5fa;
          line-height: normal;
          > div {
            padding: 10px 30px;
            background: white;
            border-bottom: 1px solid #f2f5fa;
            transition: all 0.5s;
            cursor: pointer;
            color: #414a60;
          }
          > div:hover {
            background-color: #f2f5fa;
          }
          .tips {
            color: #9fa3b0;
          }
        }
      }
      .user:hover {
        .userBox {
          display: block;
        }
      }
    }
  }
}
.goLogin {
  margin-left: 20px;
  // border: 1px solid #ff5b12;
  border: 1px solid #fff;
  border-radius: 16px;
  display: inline-block;
  height: 34px;
  line-height: 34px;
  padding: 0 9px 0 11px;
  cursor: pointer;
  transition: color 0.5s;
}
// .goLogin:hover {
//   color: #ff5b12;
// }
</style>



// WEBPACK FOOTER //
// src/components/jobNavBar/index.vue